import styled from 'styled-components';

export const StyledNavbar = styled.nav`
  width: 100%;
  display: flex;
  justify-content: center;

  padding: 1rem 0;
`;
